import { useEffect, useMemo, useState } from 'react';

const useContentShareTileIds = ({ audioVideo, providerTileIds = [], onTileRemoved }) => {
  const [directTileIds, setDirectTileIds] = useState([]);

  useEffect(() => {
    if (!audioVideo) return () => {};

    const processState = (tileState) => {
      if (!tileState || !tileState.isContent || !tileState.tileId) return;
      setDirectTileIds((prev) => {
        if (prev.includes(tileState.tileId)) return prev;
        return [...prev, tileState.tileId];
      });
    };

    const observer = {
      videoTileDidUpdate: processState,
      videoTileWasRemoved: (tileId) => {
        setDirectTileIds((prev) => prev.filter((id) => id !== tileId));
        if (onTileRemoved) onTileRemoved(tileId);
      },
    };

    audioVideo.addObserver(observer);

    try {
      (audioVideo.getAllVideoTiles?.() || []).forEach((tile) => {
        processState(tile.state?.());
      });
    } catch (_e) {
      // Non-fatal.
    }

    return () => audioVideo.removeObserver(observer);
  }, [audioVideo, onTileRemoved]);

  return useMemo(
    () => [...new Set([...(providerTileIds || []), ...directTileIds])],
    [providerTileIds, directTileIds],
  );
};

export default useContentShareTileIds;
